module.exports = __webpack_public_path__ + "static/media/skyscanner.4f1e6d25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/skyscanner.svg
// module id = 401
// module chunks = 0